import React from 'react';
import { Chip } from '@mui/material';

const STATUS = {
  saved: { label: 'Saved', color: 'success' },
  dirty: { label: 'Unsaved', color: 'warning' },
  saving: { label: 'Saving', color: 'info' },
  error: { label: 'Needs attention', color: 'error' },
  returned: { label: 'Returned', color: 'error' },
  legacy: { label: 'Current editor', color: 'default' },
  not_started: { label: 'Not saved', color: 'default' },
};

export default function VisitSectionStatus({ status = 'not_started', compact = false }) {
  const config = STATUS[status] || STATUS.not_started;
  return (
    <Chip
      size="small"
      color={config.color}
      variant={status === 'saved' ? 'filled' : 'outlined'}
      label={compact && status === 'saved' ? '✓' : config.label}
      sx={compact ? { height: 20, '& .MuiChip-label': { px: 0.75 } } : undefined}
    />
  );
}
